import React, { Component } from "react";
import Icon from "../rifa/components/layout/icon";

class Error extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            errorMessage: ''
        };
    }

    componentDidMount() {
        window.onerror = (message, source, lineno, colno, error) => {
            this.setState({ hasError: true, errorMessage: message });
            console.error('Error:', error);
        };
    }
    
    componentWillUnmount() {
        this.setState({ hasError: false, errorMessage: '' });
        window.onerror = null;
    }

    render(){
        return(
            <React.Fragment>
                {this.props.loading && !this.state.hasError &&
                    <p>{this.props.message || 'Carregando...'}</p>
                }
                {!this.props.loading && this.state.hasError &&
                    <div style={{ padding: "1rem", textAlign: 'center' }}>
                        <React.Fragment>
                            <Icon type="errorImage" color="white" key="a" />
                            <h4><strong>Parece que algo deu errado.</strong><br/></h4>
                            <p>
                                { this.state.errorMessage }
                            </p>
                            <p>Caso o erro persista, contacte o suporte.</p>
                        </React.Fragment>
                    </div>    
                }
                {!this.props.loading && !this.state.hasError &&
                    (this.props.children)
                }
            </React.Fragment>
        );
    }
}
export default Error;


// WEBPACK FOOTER //
// ./src/main/error.jsx